import { useEffect, useState } from 'react';

import { getMsUntilNextOpeningHoursBoundary, isWithinCallSupportOpeningHours } from './openingHours';

/**
 * Tracks whether call support is open. A single timer fires at the next opening, closing or midnight
 * boundary, re-evaluates and schedules the following one, so the value stays current while the flow
 * is left open. A timer delayed by a sleeping device fires late on wake-up and corrects the value then.
 */
export const useIsWithinCallSupportOpeningHours = (): boolean => {
  const [isOpen, setIsOpen] = useState(() => isWithinCallSupportOpeningHours());

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const scheduleNextCheck = () => {
      timeoutId = setTimeout(() => {
        setIsOpen(isWithinCallSupportOpeningHours());
        scheduleNextCheck();
      }, getMsUntilNextOpeningHoursBoundary());
    };

    // Re-evaluate on mount in case a boundary passed between server render and hydration.
    setIsOpen(isWithinCallSupportOpeningHours());
    scheduleNextCheck();

    return () => clearTimeout(timeoutId);
  }, []);

  return isOpen;
};
